import { ui } from '@qwyk/models';

export function deserializeLocationCode(
    code: string,
    name: string
): Partial<ui.GooglePlacesAddress> {
    const splitCode = code.split('|');
    const obj = { P: null, C: null, X: null, Y: null, G: null };
    for (const el of splitCode) {
        const split = el.split(':');
        obj[split[0]] = split[1];
    }

    return {
        formattedAddress: name,
        streetNumber: null,
        route: null,
        locality: null,
        postalCode: obj['P'],
        state: null,
        countryName: null,
        countryCode: obj['C'],
        position: {
            lat: obj['Y'],
            lng: obj['X'],
        },
        types: [],
        code: obj['P'],
        placeId: obj['G'],
        plusCode: null,
    };
}
